import { FormControlLabel, styled } from "@mui/material";

export const OptionRow = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  display: "flex",
  alignItems: "center",
  margin: 0,
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.shape.borderRadius,
  ...(isSelected && {
    backgroundColor: theme.palette.background.selected,
  }),
  "&:hover": {
    backgroundColor: isSelected
      ? theme.palette.background.selected
      : theme.palette.background.subtle,
  },
  "& .MuiFormControlLabel-label": {
    flex: 1,
    minWidth: 0,
  },
}));
